// extracted by mini-css-extract-plugin
export default {"box":"ButtonsArea_box__VgCNr","btn":"ButtonsArea_btn__EryCY"};